import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "../ui/input";
import React, { useState } from "react";
import { Button } from "../ui/button";
import { EmailIdentificationWithTheme } from "../../api";
import ButtonLoader from "../Loader/index";
import { emailRegex } from "../../validation";
import SignUpFlow from "../../Container/Auth/Layout";
import { useAuth } from "../../hooks";

function EmailAddress() {
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get("email") || "";
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const { setUserList, setFormData, formData, setSignupOtpToken } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      setError("Email is required.");
      setLoading(false);
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    const EmailExist = await EmailIdentificationWithTheme(email);
    EmailExist?.data?.otpToken && setSignupOtpToken(EmailExist?.data?.otpToken);

    setError("");

    if (EmailExist?.data?.usernameList?.length === 0) {
      setLoading(false);
      navigate(`/verify-otp?email=${encodeURIComponent(email)}`);
    }

    if (EmailExist?.data?.usernameList?.length > 0) {
      setUserList(EmailExist?.data);
      navigate(`/exist?email=${encodeURIComponent(email)}`);
      setLoading(false);
    }
  };

  return (
    <SignUpFlow
      headerText={"Welcome"}
      ParagraphText={"Enter your email address"}
    >
      <form className="space-y-[27px]" onSubmit={handleSubmit}>
        <div>
          <label
            htmlFor="username"
            className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
          >
            Email Address
          </label>
          <Input
            id="username"
            type="text"
            value={email}
            onChange={(e) =>
              setEmail(
                e.target.value.toLowerCase(),
                setFormData({
                  ...formData,
                  email: e.target.value.toLowerCase(),
                })
              )
            }
            className={`w-full h-[45px] px-3 py-2 font-geomanistBold text-[16px] ${
              error ? "border-red-500" : ""
            }`}
          />
          {error && (
            <p className="text-red-500  text-[14px] mt-1 ml-2">{error}</p>
          )}
        </div>

        <Button type="submit" variant="primary" disabled={loading}>
          {loading && <ButtonLoader className={"mr-2"} />} Continue
        </Button>
      </form>
    </SignUpFlow>
  );
}

export default EmailAddress;
